import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { ArrowRight } from "lucide-react";
import { apiClient, setAdminToken } from "../../lib/apiClient";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await apiClient.post("/auth/login", { email, password });
      const token = response.data?.access_token;
      if (token) {
        setAdminToken(token);
        navigate("/admin");
      } else {
        setError("Неочікувана відповідь від сервера.");
      }
    } catch (err) {
      console.error(err);
      setError("Невірні облікові дані або помилка сервера.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4 py-10 text-slate-900">
      <Card className="w-full max-w-md border-slate-200 bg-white shadow-xl shadow-slate-900/10">
        <CardContent className="space-y-6 p-6 sm:p-8">
          <div className="flex justify-center">
            <img 
              src="/assets/admin-logo.png" 
              alt="SLA Logo" 
              className="h-20 w-auto"
            />
          </div>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div className="space-y-1.5">
              <label className="text-xs font-medium text-slate-700" htmlFor="admin-email">
                Електронна пошта
              </label>
              <Input
                id="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-white text-slate-900 border-slate-300"
                autoComplete="username"
              />
            </div>
            <div className="space-y-1.5">
              <label className="text-xs font-medium text-slate-700" htmlFor="admin-password">
                Пароль
              </label>
              <Input
                id="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-white text-slate-900 border-slate-300"
                autoComplete="current-password"
              />
            </div>
            {error && <p className="text-xs text-red-500">{error}</p>}
            <Button
              type="submit"
              disabled={loading}
              className="group mt-2 w-full rounded-full bg-amber-500 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-900 shadow-lg shadow-amber-500/40 transition-colors hover:bg-amber-400 disabled:opacity-70"
            >
              <span>{loading ? "Вхід..." : "Увійти в адмін"}</span>
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
